(function () { // eslint-disable-line
  window.addEventListener('keydown', (e) => {
    if (e.keyIdentifier === 'U+0008' || e.keyIdentifier === 'Backspace' || e.keyCode === 8) {
      const nodeName = e.target.nodeName.toLowerCase()
      const exclude = ['w-e-text']
      const cls = e.target.className
      if (!(nodeName === 'input' && (e.target.type !== 'checkbox' && e.target.value)) &&
        (nodeName !== 'textarea') && !exclude.includes(cls)) {
        e.preventDefault()
        return false
      }
    }
    return true
  }, true)

  window.onhashchange = () => {
    $(document.activeElement).blur()
  }
}())
